import { Component } from "@theme/component";

export class VariantDropdownComponent extends Component {
  requiredRefs = ['options']

  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();
    this.#initOptionEvents();
    this.#handleDropdownToggle();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  #initOptionEvents() {
    const { signal } = this.#abortController;

    const children = this.refs.options?.children;

    for (const child of children) {
      child.addEventListener('click', this.#handleChangeEvent.bind(this), { signal });
    }
  }

  /**
   * @param {Event} event
   */
  #handleChangeEvent(event) {
    const select = this.nextElementSibling
    if (!select) return;
    const value = event.target.dataset?.value;
    const isAvailable = event.target.dataset?.isAvailable;
    this.title = `${value} ${(isAvailable == 'false') ? 'Unavailable' : ''}`.trim();
    select.value = value;
    select?.dispatchEvent(new Event('change', { bubbles: true }));
    this.#close();
    this.#setActive(event);
  }

  #setActive(event) {
    this.querySelector('li.active')?.classList.remove('active');
    event.target.classList.add('active');
  }

  #handleDropdownToggle() {
    this.label.addEventListener('click', this.#toggleDropdown.bind(this));
    document.body.addEventListener('click', this.#handleOutsideClickEvent.bind(this));
  }

  #handleOutsideClickEvent(event) {
    if (!this.contains(event.target)) {
      this.#close();
    }
  }
  
  #toggleDropdown(event) {
    if (this.isOpen) this.#close(); else this.#open();
  }

  #open() {
    this.setAttribute('open', 'true');
  }

  #close() {
    this.removeAttribute('open');
  }

  set title(value) {
    const el = this.refs.label;
    if (!el) return;
    el.querySelector('.title').textContent = value;
  }

  get title() {
    const el = this.refs.label;
    if (!el) throw new Error('[ref="label"] > .title is required');
    return el.querySelector('.title');
  }

  get label() {
    return this.refs.label;
  }

  get isOpen() {
    return this.hasAttribute('open');
  }
}

if (!customElements.get('variant-dropdown')) {
  customElements.define('variant-dropdown', VariantDropdownComponent);
}